import { AuthClient, AuthType } from "@padloc/core/src/auth";
import { getDialog } from "../dialog";
import { translate as $l } from "@padloc/locale/src/translate";
import { html } from "lit";
import "../../elements/prompt-dialog";
import { PromptDialog } from "../../elements/prompt-dialog";

export class EmailAuthClient implements AuthClient {
    supportsType(type: AuthType) {
        return type === AuthType.Email;
    }

    async _promptCode({ email }: { email: string; sentAt: string; subject: string }) {
        const promptDialog = (await getDialog("pl-prompt-dialog")) as PromptDialog;

        const message = html`<div class="break-words">
            ${$l(`Enter the 6-digit CryptidPass verification code sent to {0}.`, email)}
        </div>`;

        const code = await promptDialog.show({
            title: $l("Email Authentication"),
            placeholder: $l("Enter Verification Code"),
            confirmLabel: $l("Submit"),
            type: "number",
            pattern: "[0-9]*",
            message,
            validate: async (val) => {
                if (!val || val.length !== 6) {
                    throw $l("Please enter the 6-digit verification code!");
                }

                return val;
            },
        });

        return code ? { code } : null;
    }

    async prepareRegistration(params: { email: string; sentAt: string; subject: string }) {
        return this._promptCode(params);
    }

    async prepareAuthentication(params: { email: string; sentAt: string; subject: string }) {
        return this._promptCode(params);
    }
}
